import {Button, Spin, Table, Space, Popconfirm, message} from 'antd';
import {useEffect, useState} from 'react';
import {Course} from '../../graphql/API';
import {Link} from 'react-router-dom';
import Title from 'antd/es/typography/Title';
import {DeleteOutlined} from '@ant-design/icons';

// OLD CODE - Commented out (kept for reference)
// interface PlanTableProps {
//   data: Array<Course> | [];
//   title: string;
//   language:string;
// }

// NEW CODE - Using @PikaDoApp/npm-pikado-logic
interface PlanTableProps {
  data: Array<any> | []; // Plan data from pikado-logic
  title: string;
  language: string;
  onDelete: (id: string) => Promise<void>;
}

export const PlanTable: React.FC<PlanTableProps> = ({
  data,
  title,
  language,
  onDelete,
}) => {
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // OLD CODE - Commented out (kept for reference)
  // const columns = [
  //   {
  //     title: 'Course name',
  //     dataIndex: 'name',
  //     sorter: (a: any, b: any) => {
  //       return a.name.localeCompare(b.name);
  //     },
  //     width:"10%"
  //
  //   },
  //   {
  //     title: 'Level',
  //     defaultSortOrder: 'ascend',
  //     dataIndex: ['level', 'name'],
  //     sorter: (a: any, b: any) => {
  //       return a.level?.name?.localeCompare(b?.level.name);
  //     },
  //     width:"5%",
  //     align:"center"
  //
  //   },
  //   {
  //     title: 'Plan ID',
  //     dataIndex: ['plan', 'id'],
  //     sorter: (a: any, b: any) => {
  //       return a.language.country.localeCompare(b.language.country);
  //     },
  //     render: (planId: string) => <Link to={'/plans/' + planId}>{planId}</Link>,
  //     width:"25%"
  //   },
  //
  //   {
  //     title: 'course ID',
  //     dataIndex: 'id',
  //     sorter: (a: any, b: any) => {
  //       return a.id.localeCompare(b.id);
  //     },
  //     sortDirections: ['descend'],
  //     width:"25%"
  //   },
  // ];

  // NEW CODE - Using @PikaDoApp/npm-pikado-logic
  const columns = [
    {
      title: 'Plan Name',
      dataIndex: 'name',
      sorter: (a: any, b: any) => {
        return a.name.localeCompare(b.name);
      },
      width: '15%',
    },
    {
      title: 'Level',
      defaultSortOrder: 'ascend',
      dataIndex: ['level', 'name'],
      sorter: (a: any, b: any) => {
        const aLevel = typeof a.level === 'object' ? a.level?.name : a.level;
        const bLevel = typeof b.level === 'object' ? b.level?.name : b.level;
        return aLevel?.localeCompare(bLevel) || 0;
      },
      width: '10%',
      align: 'center' as const,
      render: (levelData: any) => {
        return typeof levelData === 'object'
          ? levelData?.name
          : levelData || 'N/A';
      },
    },
    {
      title: 'Grade',
      dataIndex: ['grade', 'name'],
      sorter: (a: any, b: any) => {
        const aGrade = typeof a.grade === 'object' ? a.grade?.name : a.grade;
        const bGrade = typeof b.grade === 'object' ? b.grade?.name : b.grade;
        return (aGrade || '').localeCompare(bGrade || '') || 0;
      },
      width: '10%',
      align: 'center' as const,
      render: (gradeData: any) => {
        return typeof gradeData === 'object'
          ? gradeData?.name
          : gradeData || 'N/A';
      },
    },
    {
      title: 'Curriculum',
      dataIndex: ['curriculum', 'name'],
      sorter: (a: any, b: any) => {
        const aCurr =
          typeof a.curriculum === 'object' ? a.curriculum?.name : a.curriculum;
        const bCurr =
          typeof b.curriculum === 'object' ? b.curriculum?.name : b.curriculum;
        return (aCurr || '').localeCompare(bCurr || '') || 0;
      },
      width: '10%',
      align: 'center' as const,
      render: (currData: any) => {
        return typeof currData === 'object'
          ? currData?.name
          : currData || 'N/A';
      },
    },
    {
      title: 'Duration (days)',
      dataIndex: 'duration',
      sorter: (a: any, b: any) => {
        return (a.duration || 0) - (b.duration || 0);
      },
      width: '8%',
      align: 'center' as const,
      render: (duration: number) => duration || 'N/A',
    },
    {
      title: 'Plan ID',
      dataIndex: 'id',
      sorter: (a: any, b: any) => {
        return a.id.localeCompare(b.id);
      },
      render: (planId: string) => <Link to={'/plans/' + planId}>{planId}</Link>,
      width: '20%',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      sorter: (a: any, b: any) => {
        return (
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
      },
      render: (date: string) => new Date(date).toLocaleDateString(),
      sortDirections: ['descend'],
      width: '10%',
    },
    {
      title: 'Actions',
      key: 'actions',
      dataIndex: 'id',
      render: (id: string) => (
        <Space>
          <Link to={'/plans/' + id + '/edit'}>
            <Button>Edit</Button>
          </Link>
          {/* <Popconfirm
            title="Are you sure you want to delete this plan?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => onDelete(id)}>
            <Button danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm> */}
        </Space>
      ),
      width: '12%',
    },
  ];

  return (
    <>
      {!isError && !isLoading && (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            {title && (
              <Title
                style={{
                  fontSize: '1rem',
                  color: '#6c757d',
                  paddingLeft: '1rem',
                }}>
                Curriculum Name:{' '}
                <span style={{color: 'black'}}>
                  {title !== 'undefined' ? title : 'None'}{' '}
                </span>{' '}
              </Title>
            )}
            {/* { language && <Title style={{fontSize:"1rem", color:"#6c757d",paddingRight:"1rem",marginTop:"0"}}>Language: <span style={{color:'black'}}>{language} </span> </Title> } */}
          </div>
          <Table
            pagination={{defaultPageSize: 10, hideOnSinglePage: true}}
            expandRowByClick={true}
            //@ts-ignore
            columns={columns}
            dataSource={data}
          />
        </>
      )}
      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Enrollments fetching error ⚠️</Title>}
    </>
  );
};
